<template class="px-0 mx-0 pt-0">
  <router-view></router-view>
</template>

<script>
export default {
  name: 'CreateOrEditStory',
  components: {
  },
  methods:{
        saveCurrentStory:async function () {
        return this.$store.dispatch("setNewStories", {...this.cache})
    }
  }
}
</script>
<style>
.createNewStory{
padding: 0px;
margin: 0px;
}
</style>